/**
 * Indique si l'usager peut envoyer un message dans la conversation active.
 * L'historique reste lisible même si la mission n'est plus dans le groupe courant.
 */
export function u3204CanSendInActiveConversation(
  hasUserGroup: boolean,
  activeConversationId: string | null,
  activeMissionId: string | null | undefined,
  accessibleMissionIds: ReadonlySet<string>,
): boolean {
  if (!activeConversationId || !hasUserGroup || !activeMissionId) {
    return false;
  }
  return accessibleMissionIds.has(activeMissionId);
}
